<template>
  <div class="container">
    <div class="text-container">
      <div>
        <p>
          <b><span>¡Lo siento!</span></b>
          <br>
          <br>
          En este momento no podemos realizar esta operación
        </p>
      </div>
      <div v-if="this.returnButton" class="container-info">
        <a @click="$router.go(-1)">
          Regresar
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotAvailable',
  props: { returnButton: Boolean }
}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 8em auto;
  }
  .text-container{
    text-align: center;
    padding: 15px;
    margin-top: 1em;
  }
  .container-info{
    margin-top: 1em;
  }
  .container img {
    width: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotAvailable.vue